// extracted by mini-css-extract-plugin
export default {"VideoPlayerContainer":"_VideoPlayerContainer--ZaGDN","Small":"_Small--UQeZG"};